import React, { Component } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";

import Home from "./routes/Home";
// import Form1Route from "./routes/form1";
// import Form2Route from "./routes/form2";
import Form3Route from "./routes/form3";

class App extends Component {
  render() {
    if (process.env.NODE_ENV === "production") {
      return (
        <HashRouter>
          <Switch>
          <Route path="/" component={Form3Route} />
          </Switch>
        </HashRouter>
      );
    }

    return (
      <HashRouter>
        <Switch>
          {/* <Route path="/form1" component={Form1Route} />
          <Route path="/aura-fund-II" component={Form2Route} /> */}
          <Route path="/cvc" component={Form3Route} />
          <Route exact path="/" component={Home} />
        </Switch>
      </HashRouter>
    );
  }
}

export default App;
